export default __webpack_public_path__ + "static/media/benefit-connect.c5782d38.png";